import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 100px;\n  width: 375px;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useEffect, useState } from 'react';
import { SEARCH_OVERLAY, SEARCH_BAR_TOOLTIP } from '../../utils/testing/TestIDs';
import { TooltipV2 as Tooltip } from '../../TooltipV2';
import styled from '../../utils/styling/styled-components';
import { Overlay } from '../components/Overlay';
import { useRecentSearchesDropdown } from '../hooks/useRecentSearchesDropdown';
import { Results } from './Results';
import { SearchBar } from './SearchBar';
var SearchBarContainer = styled.div(_templateObject(), function (props) {
  return props.showOverlay && 'z-index: 200;';
});
export var Search = function Search(_ref) {
  var focusOnLoad = _ref.focusOnLoad,
      isLoading = _ref.isLoading,
      placeholder = _ref.placeholder,
      onExitClick = _ref.onExitClick,
      _ref$searchString = _ref.searchString,
      searchString = _ref$searchString === void 0 ? '' : _ref$searchString,
      tooltipText = _ref.tooltipText,
      onHandleBlur = _ref.onHandleBlur,
      onHandleChange = _ref.onHandleChange,
      onHandleClear = _ref.onHandleClear,
      onHandleClick = _ref.onHandleClick,
      onContainerClick = _ref.onContainerClick,
      notFoundMessage = _ref.notFoundMessage,
      _ref$overlayEnabled = _ref.overlayEnabled,
      overlayEnabled = _ref$overlayEnabled === void 0 ? true : _ref$overlayEnabled,
      _ref$showResults = _ref.showResults,
      showResults = _ref$showResults === void 0 ? true : _ref$showResults,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$showTooltipOnLoa = _ref.showTooltipOnLoad,
      showTooltipOnLoad = _ref$showTooltipOnLoa === void 0 ? false : _ref$showTooltipOnLoa,
      _ref$results = _ref.results,
      results = _ref$results === void 0 ? [] : _ref$results,
      className = _ref.className,
      type = _ref.type;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showOverlay = _useState2[0],
      setShowOverlay = _useState2[1];

  var _useRecentSearchesDro = useRecentSearchesDropdown(),
      node = _useRecentSearchesDro.node,
      showOptions = _useRecentSearchesDro.showOptions,
      setShowOptions = _useRecentSearchesDro.setShowOptions;

  var _useState3 = useState(showTooltipOnLoad),
      _useState4 = _slicedToArray(_useState3, 2),
      showTooltip = _useState4[0],
      setShowTooltip = _useState4[1];

  var handleClick = function handleClick() {
    setShowTooltip(false);
    setShowOptions(true);

    if (onHandleClick) {
      onHandleClick();
    }
  };

  useEffect(function () {
    setShowOverlay(overlayEnabled && showOptions);
  }, [showOptions]);

  var handleChange = function handleChange(event) {
    setShowTooltip(false);

    if (onHandleChange) {
      onHandleChange(event);
    }

    setShowOptions(true);
  };

  var handleBlur = function handleBlur(event) {
    if (onHandleBlur) {
      onHandleBlur(event);
    }
  };

  var handleClear = function handleClear() {
    setShowOptions(false);

    if (onHandleClear) {
      onHandleClear();
    }
  };

  var handleExit = function handleExit() {
    setShowOptions(false);

    if (onExitClick) {
      onExitClick();
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, overlayEnabled && /*#__PURE__*/React.createElement(Overlay, {
    "data-testid": SEARCH_OVERLAY,
    showOverlay: showOverlay
  }), /*#__PURE__*/React.createElement(Tooltip, {
    placement: "bottom",
    content: tooltipText,
    visibleOverride: showTooltip,
    mobileOverrides: {
      containerWidth: '100%'
    },
    testId: SEARCH_BAR_TOOLTIP
  }, /*#__PURE__*/React.createElement(SearchBarContainer, {
    showOverlay: showOverlay,
    ref: node,
    className: className,
    onClick: onContainerClick
  }, /*#__PURE__*/React.createElement(SearchBar, {
    placeholder: placeholder,
    searchString: searchString,
    handleChange: handleChange,
    handleBlur: handleBlur,
    handleClear: handleClear,
    handleClick: handleClick,
    handleExit: handleExit,
    showOverlay: showOverlay,
    disabled: disabled,
    focusOnLoad: focusOnLoad,
    type: type
  }, showResults && showOptions && /*#__PURE__*/React.createElement(Results, {
    isLoading: isLoading,
    searchString: searchString,
    results: results,
    notFoundMessage: notFoundMessage
  })))));
};